import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from 'src/app/shared/config';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../admin-dashboard/product/product.service';
import { combineLatest, Subject, Subscription, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators'
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { Moment } from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { MatSelectChange } from '@angular/material/select';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';



@Component({
  selector: 'app-company-report-generator',
  templateUrl: './company-report-generator.component.html',
  styleUrls: ['./company-report-generator.component.css'],
})



export class CompanyReportGeneratorComponent implements OnInit, OnDestroy {

  public todayDate = new Date();
  public siteId: string;

  inputDateFrom: Date;
  inputDateTo: Date;

  toTime ;
  endTime ;
  timeSelected: string = "TODAY";
  product$;
  productFilter$ = new Subject()
  filteredProduct$;



  systemId;

  siteData$: Observable<any>;
  employeeName;
  productName;
  projectName;
  systemName;
  departmentName;
  siteName;
  focus = "ALL";
  filterString = "";
  filteredStatesSub: Subscription;
  timer;
  searchResultReceived = false;

  // Datetime picker settings
  newdate: Date = new Date();
  settings = {
    bigBanner: true,
    timePicker: true,
    format: 'dd-MMM-yyyy hh:mm',
    defaultOpen: false
  }

  constructor(private config: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
  ) {
    this.productService.getProducts();

  }



  onSubmit(form) {

    this.router.navigate(['../companyreport'], { relativeTo: this.route })
    let dateFrom;
    let dateTo;

    if(this.toTime && this.endTime){
     
      dateFrom = moment(this.inputDateFrom).set('hour',this.toTime.split(':')[0]).set('minute',this.toTime.split(':')[1]).tz('Europe/Oslo').unix();
      dateTo= moment(this.inputDateTo).set('hour',this.endTime.split(':')[0]).set('minute',this.endTime.split(':')[1]).tz('Europe/Oslo').unix();
    }else{
      dateFrom = moment(this.inputDateFrom).tz('Europe/Oslo').unix();
      dateTo= moment(this.inputDateTo).tz('Europe/Oslo').unix();
    }

    setTimeout(() => {
      this.router.navigate(['companyreportgenerate'], {
        queryParams:
        {
          focusBy: this.focus,
          dateFrom,
          dateTo,
         companyId: this.config.getCompanyId()
        }, relativeTo: this.route
      })
    }, 200)

  }
  async ngOnInit() {

    this.setTimePeriode('TODAY');
    // this.product$ = this.productService.getProducts();
    this.product$ = this.productService.data;

    this.filteredProduct$ = combineLatest(
      this.product$, this.productFilter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
        if (this.filterString != filter) {
          this.searchResultReceived = false;
        }
        this.filterString = filter as string;

        
        return ((data as Array<{}>).filter(option => option['productNumberLowerCase'].toLowerCase().includes(filter))) ||
          ((data as Array<{}>).filter(option => option['searchString'].toLowerCase().includes(filter)))

      }))

    this.filteredStatesSub = this.filteredProduct$.subscribe(data => {
      if (this.filterString.length > 2 && !this.searchResultReceived) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.productService.getProductByNameAndPartNumber(this.filterString);
          this.searchResultReceived = true;


        }, 1000)
      }
    })


  }

  setTimePeriodeEvent(event: MatSelectChange) {
    this.setTimePeriode(event.value);
  }

  setTimePeriode(value) {
    try {

      const now = moment();

      let from: Moment;
      let to: Moment;
      console.log(value)
      switch (value) {
        case 'TODAY':
          from = moment(now).startOf('day');
          to = now.endOf('day');
          // this.toTime = "00:00"
          // this.endTime = "23:59"
          break;
        case 'YESTERDAY':
          from = moment(now).subtract(1, 'days').startOf('day');
          to = moment(from).endOf('day');
          
          break;
        case '24H':
          from = moment(now).subtract(1, 'days');
          to = moment(now);
          break;
        case 'THIS_MONTH':
          from = moment(now).startOf('month');
          to = moment(now).endOf('day');
          break;
        case 'LAST_MONTH':
          from = moment(now).subtract(1, 'month').startOf('month');
          to = moment(from).endOf('month');
          break;
        case 'CUSTOM':
          return;
          break;
        default:
          throw new Error("Unhandled select time case!")
      }

      this.inputDateFrom = from.toDate();
      this.inputDateTo = to.toDate();


    } catch (err) {
      console.log(err.message)
    }

  }

  applyProductFilter(filterValue: string) {
    this.productFilter$.next(filterValue.toLowerCase());
  }






  onReset(form) {
    // this.employeeId = "";
    // this.productId = "";
    // this.projectId = "";
    // this.systemId = "";
    // this.router.navigate(['../report'], { relativeTo: this.route })
  }


  setCustomRange(event: MatDatepickerInputEvent<Date>, picker: 'start' | 'end') {

    if (picker === 'start') {
      this.inputDateFrom = moment(event.value).startOf('day').toDate();
    } else {
      this.inputDateTo = moment(event.value).endOf('day').toDate()
    }
  }

  changeFocus(value) {
    
    this.focus = value;
  }
  setToTime() {
    this.toTime = document.getElementById("startTime")['value'];
    
    // this.inputDateTo =  moment(this.inputDateTo).set('hour',startTime['value'].split(':')[0]).set('minute',startTime['value'].split(':')[1]).toDate()
    //  console.log( this.inputDateTo)
  }
  setEndTime() {
    this.endTime = document.getElementById("endTime")['value'];
   
   
    // this.inputDateFrom =  moment(this.inputDateFrom).set('hour',endTime['value'].split(':')[0]).set('minute',endTime['value'].split(':')[1]).toDate()

    // console.log(endTime['value'])
    // console.log( this.inputDateFrom)

  }


  ngOnDestroy(): void {
    if (this.filteredStatesSub) this.filteredStatesSub.unsubscribe();
  }
}
